import DeferredValueTimeline from '../DeferredValueTimeline';

export default function DeferredWorkingPerfectly() {
  return (
    <DeferredValueTimeline
      video={{
        src: '/videos/use-deferred-value/deferred-04-perfect-v2',
        length: 60 + 60 + 39,
      }}
      clicks={[12, 50, 60 + 33]}
      renders={[
        {
          type: 'initial',
          start: 12,
          end: 12 + 15,
          values: { count: 1, dCount: 0 },
        },
        {
          type: 'deferred',
          start: 27,
          end: 50,
          values: { count: 1, dCount: 1 },
          interrupted: true,
        },
        {
          type: 'initial',
          start: 50,
          end: 50 + 15,
          values: { count: 2, dCount: 0 },
        },
        {
          type: 'deferred',
          start: 50 + 15,
          end: 93,
          values: { count: 2, dCount: 2 },
          interrupted: true,
        },
        {
          type: 'initial',
          start: 93,
          end: 93 + 15,
          values: { count: 3, dCount: 0 },
        },
        {
          type: 'deferred',
          start: 93 + 15,
          end: 120 + 32,
          values: { count: 3, dCount: 3 },
        },
      ]}
    />
  );
}
